/*
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

import { ILogoutRepository } from '../ILogoutRepository';
import { RequestsHandlerInstance } from '../utils/RequestsHandler';

export default class LogoutRepository implements ILogoutRepository {
  // eslint-disable-next-line no-empty-function
  constructor(private requestsHandler: RequestsHandlerInstance) {}

  async logout(): Promise<void> {
    await this.requestsHandler.delete('logout');
  }
}
